import {CurrentPlants} from "./CurrentPlants";

export const CloneTab = ({room, stage, roomMap, onApiFail, session, refresh, onRefresh, props}) => {
    return <CurrentPlants room={room} stage={stage} roomMap={roomMap} session={session} onApiFail={onApiFail} refresh={refresh} onRefresh={onRefresh}/>
}